<ng-template #snackBar>
    <div [class.success]="type === 'success'" [class.info]="type === 'info'"  class="container">
        <div class="message">

            <p >
                 <mat-icon *ngIf="type === 'success'">check</mat-icon>
                 <mat-icon *ngIf="type === 'error'">error</mat-icon>
                 <mat-icon *ngIf="type === 'info'">error_outline</mat-icon>

                {{ msg }}
            </p>

            <p>{{ msg2 }}</p>
        </div>

        <button mat-button type="button" class="close-btn" (click)="dismiss()"><mat-icon>close</mat-icon></button>
    </div>
</ng-template>
